import React, { useEffect, useState } from "react";
import axios from "axios";

export default function GoogleFilesTable() {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/integration/google-files/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        );
        setFiles(response.data.files || []);
      } catch (err) {
        console.error("Error fetching files:", err);
        setError(err);
      }
    };

    fetchFiles();
  }, []);

  const handleTrain = async ({ file_id }) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/integration/google-files-train/`,
        { file_id },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      setFiles((prevFiles) =>
        prevFiles.map((file) =>
          file.id === file_id ? { ...file, is_trained: true } : file
        )
      );
    } catch (err) {
      console.error("Error training file:", err);
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return <div style={{ color: "red", fontWeight: "bold" }}>Google Docs is not integrated Yet</div>;
  }

  if (!files.length) {
    return <div style={{ fontStyle: "italic" }}>Loading files...</div>;
  }

  if (loading) {
    return <div style={{ fontStyle: "italic" }}>Training...</div>;
  }

  if (!files.length) {
    return <div style={{ fontStyle: "italic" }}>No files found.</div>;
  }

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ marginBottom: "15px" }}>Google Files</h2>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          textAlign: "left",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f2f2f2" }}>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>File Name</th>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Web View Link</th>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {files.map((file) => (
            <tr key={file.id}>
              <td style={{ padding: "10px", border: "1px solid #ddd" }}>{file.file_name}</td>
              <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                <a href={file.web_view_link} target="_blank" rel="noopener noreferrer">
                  View
                </a>
              </td>
              <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                {file.is_trained ? (
                  <span style={{ color: "green" }}>Trained</span>
                ) : (
                  <button
                  style={{
                    padding: "5px 10px",
                    backgroundColor: "#4CAF50",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleTrain({ file_id: file.id })}
                >
                  Train
                </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
